// Export an array of topics for VA 1st Grade Science
const va5thSocialStudiesQuizContent = [
  // Continents and Oceans - Drag and Drop
  {
    "slug": "continentsandoceans",
    "title": "Continents and Oceans",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each continent to the label.",
        "options": [
          { "id": "africa", "text": "Africa", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "asia", "text": "Asia", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "europe", "text": "Europe", "image": "", "targetText": "Continent", "targetImage": "" }
        ]
      },
      {
        "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each ocean to the label.",
        "options": [
          { "id": "pacific", "text": "Pacific", "image": "", "targetText": "Ocean", "targetImage": "" },
          { "id": "atlantic", "text": "Atlantic", "image": "", "targetText": "Ocean", "targetImage": "" },
          { "id": "indian", "text": "Indian", "image": "", "targetText": "Ocean", "targetImage": "" }
        ]
      },
      {
        "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match the cold ocean to its name.",
        "options": [
          { "id": "arctic", "text": "Arctic", "image": "", "targetText": "Cold Ocean", "targetImage": "" },
          { "id": "southern", "text": "Southern", "image": "", "targetText": "Cold Ocean", "targetImage": "" },
          { "id": "pacific2", "text": "Pacific", "image": "", "targetText": "Not Cold", "targetImage": "" }
        ]
      },
      {
        "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match North America, South America, and Australia to their type.",
        "options": [
          { "id": "northamerica", "text": "North America", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "southamerica", "text": "South America", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "australia", "text": "Australia", "image": "", "targetText": "Continent", "targetImage": "" }
        ]
      },
      {
        "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Africa, Antarctica, and Asia to their type.",
        "options": [
          { "id": "africa2", "text": "Africa", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "antarctica", "text": "Antarctica", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "asia2", "text": "Asia", "image": "", "targetText": "Continent", "targetImage": "" }
        ]
      }
    ]
  },
  
// Areas - Drag and Drop
{
  "slug": "areas",
  "title": "Areas",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match the landform to its description.",
      "options": [
        { "id": "coastalplain", "text": "Coastal Plain", "image": "", "targetText": "Flat land", "targetImage": "" },
        { "id": "appalachian", "text": "Appalachian", "image": "", "targetText": "Highlands", "targetImage": "" },
        { "id": "interior", "text": "Interior Lowlands", "image": "", "targetText": "Grassy hills", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each flat land region to its name.",
      "options": [
        { "id": "interior2", "text": "Interior", "image": "", "targetText": "Flat lands", "targetImage": "" },
        { "id": "greatplains", "text": "Great Plains", "image": "", "targetText": "Flat lands", "targetImage": "" },
        { "id": "basin", "text": "Basin & Range", "image": "", "targetText": "Lowest point", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Rocky Mountains, Basin & Range, and Coastal Range.",
      "options": [
        { "id": "rocky", "text": "Rocky", "image": "", "targetText": "Rugged", "targetImage": "" },
        { "id": "basin2", "text": "Basin", "image": "", "targetText": "Lowest point", "targetImage": "" },
        { "id": "coastal", "text": "Coastal Range", "image": "", "targetText": "Fertile valleys", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each range to its region.",
      "options": [
        { "id": "coastal2", "text": "Coastal", "image": "", "targetText": "California to Canada", "targetImage": "" },
        { "id": "rocky2", "text": "Rocky", "image": "", "targetText": "Alaska to Mexico", "targetImage": "" },
        { "id": "appalachian2", "text": "Appalachian", "image": "", "targetText": "Canada to Alabama", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Great Plains, Coastal Plain, and Appalachian.",
      "options": [
        { "id": "greatplains2", "text": "Great Plains", "image": "", "targetText": "Grasslands", "targetImage": "" },
        { "id": "coastal3", "text": "Coastal", "image": "", "targetText": "Atlantic Ocean", "targetImage": "" },
        { "id": "appalachian3", "text": "Appalachian", "image": "", "targetText": "Highlands", "targetImage": "" }
      ]
    }
  ]
},


// Major Bodies - Drag and Drop
{
  "slug": "majorbodies",
  "title": "Major Bodies",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each river to its explorers.",
      "options": [
        { "id": "columbia", "text": "Columbia", "image": "", "targetText": "Lewis & Clark", "targetImage": "" },
        { "id": "colorado", "text": "Colorado", "image": "", "targetText": "Spanish", "targetImage": "" },
        { "id": "gulfmexico", "text": "Gulf of Mexico", "image": "", "targetText": "Spanish/French", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match rivers to farm transport.",
      "options": [
        { "id": "mississippi", "text": "Mississippi", "image": "", "targetText": "Farm products", "targetImage": "" },
        { "id": "missouri", "text": "Missouri", "image": "", "targetText": "Farm products", "targetImage": "" },
        { "id": "ohio", "text": "Ohio", "image": "", "targetText": "West travel", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each Great Lake to its group.",
      "options": [
        { "id": "superior", "text": "Lake Superior", "image": "", "targetText": "Great Lakes", "targetImage": "" },
        { "id": "michigan", "text": "Lake Michigan", "image": "", "targetText": "Great Lakes", "targetImage": "" },
        { "id": "erie", "text": "Lake Erie", "image": "", "targetText": "Great Lakes", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match the Atlantic and Pacific Oceans to their use.",
      "options": [
        { "id": "atlantic", "text": "Atlantic", "image": "", "targetText": "World route", "targetImage": "" },
        { "id": "pacific", "text": "Pacific", "image": "", "targetText": "World route", "targetImage": "" },
        { "id": "gulfmexico2", "text": "Gulf of Mexico", "image": "", "targetText": "Mexico route", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each of the Great Lakes to their group.",
      "options": [
        { "id": "huron", "text": "Lake Huron", "image": "", "targetText": "Great Lakes", "targetImage": "" },
        { "id": "ontario", "text": "Lake Ontario", "image": "", "targetText": "Great Lakes", "targetImage": "" },
        { "id": "erie2", "text": "Lake Erie", "image": "", "targetText": "Great Lakes", "targetImage": "" }
      ]
    }
  ]
},


// Pueblo & Lakota - Multiple Choice
{
  "slug": "puebloandlakota",
  "title": "Pueblo & Lakota",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Where did the Pueblo people live?",
      "questionImage": "",
      "answers": [
        { "text": "Southwest", "correct": true, "image": "" },
        { "text": "Plains", "correct": false, "image": "" },
        { "text": "Canada", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What homes did the Lakota build?",
      "questionImage": "",
      "answers": [
        { "text": "Teepees", "correct": true, "image": "" },
        { "text": "Cliff homes", "correct": false, "image": "" },
        { "text": "Stone huts", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What was the Pueblo transportation?",
      "questionImage": "",
      "answers": [
        { "text": "Walking", "correct": true, "image": "" },
        { "text": "Horses", "correct": false, "image": "" },
        { "text": "Boats", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What skill did the Lakota have?",
      "questionImage": "",
      "answers": [
        { "text": "Hunting", "correct": true, "image": "" },
        { "text": "Farming only", "correct": false, "image": "" },
        { "text": "Sailing", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where did the Lakota live?",
      "questionImage": "",
      "answers": [
        { "text": "Plains", "correct": true, "image": "" },
        { "text": "Southwest", "correct": false, "image": "" },
        { "text": "Mountains", "correct": false, "image": "" }
      ]
    }
  ]
},

// As a Native - Multiple Choice
{
  "slug": "asanative",
  "title": "As a Native",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What food did American Natives get from water?",
      "questionImage": "",
      "answers": [
        { "text": "Fish", "correct": true, "image": "" },
        { "text": "Corn", "correct": false, "image": "" },
        { "text": "Wheat", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did they grow in fields?",
      "questionImage": "",
      "answers": [
        { "text": "Crops", "correct": true, "image": "" },
        { "text": "Iron", "correct": false, "image": "" },
        { "text": "Cloth", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did they make clothes from?",
      "questionImage": "",
      "answers": [
        { "text": "Plants", "correct": false, "image": "" },
        { "text": "Animal skins", "correct": false, "image": "" },
        { "text": "Both", "correct": true, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What type of resources were animals?",
      "questionImage": "",
      "answers": [
        { "text": "Natural", "correct": true, "image": "" },
        { "text": "Capital", "correct": false, "image": "" },
        { "text": "Human", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What type of resources were canoes and bows?",
      "questionImage": "",
      "answers": [
        { "text": "Capital", "correct": true, "image": "" },
        { "text": "Human", "correct": false, "image": "" },
        { "text": "Natural", "correct": false, "image": "" }
      ]
    }
  ]
},

// Countries Explored - Multiple Choice
{
  "slug": "countriesexplored",
  "title": "Countries Explored",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What was one reason countries explored?",
      "questionImage": "",
      "answers": [
        { "text": "Gold", "correct": true, "image": "" },
        { "text": "Sleep", "correct": false, "image": "" },
        { "text": "Games", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Explorers wanted to spread what?",
      "questionImage": "",
      "answers": [
        { "text": "Religion", "correct": true, "image": "" },
        { "text": "Clothes", "correct": false, "image": "" },
        { "text": "Music", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What was one challenge explorers faced?",
      "questionImage": "",
      "answers": [
        { "text": "Diseases", "correct": true, "image": "" },
        { "text": "Fast travel", "correct": false, "image": "" },
        { "text": "Easy maps", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did explorers exchange with others?",
      "questionImage": "",
      "answers": [
        { "text": "Goods", "correct": true, "image": "" },
        { "text": "Boats", "correct": false, "image": "" },
        { "text": "Sand", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did explorers claim?",
      "questionImage": "",
      "answers": [
        { "text": "Territories", "correct": true, "image": "" },
        { "text": "Stars", "correct": false, "image": "" },
        { "text": "Clouds", "correct": false, "image": "" }
      ]
    }
  ]
},

// When They Came - Multiple Choice
{
  "slug": "whentheycame",
  "title": "When They Came",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What did the Spanish bring to America?",
      "questionImage": "",
      "answers": [
        { "text": "Christianity", "correct": true, "image": "" },
        { "text": "Silk", "correct": false, "image": "" },
        { "text": "Tea", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the English claim in America?",
      "questionImage": "",
      "answers": [
        { "text": "Land", "correct": true, "image": "" },
        { "text": "Diamonds", "correct": false, "image": "" },
        { "text": "Spices", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the English do with Native Americans?",
      "questionImage": "",
      "answers": [
        { "text": "Traded", "correct": true, "image": "" },
        { "text": "Ignored", "correct": false, "image": "" },
        { "text": "Enslaved", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the French spread?",
      "questionImage": "",
      "answers": [
        { "text": "Religion", "correct": true, "image": "" },
        { "text": "Gold", "correct": false, "image": "" },
        { "text": "Cotton", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the French set up?",
      "questionImage": "",
      "answers": [
        { "text": "Trading posts", "correct": true, "image": "" },
        { "text": "Castles", "correct": false, "image": "" },
        { "text": "Ships", "correct": false, "image": "" }
      ]
    }
  ]
},

// West Africa Power - Drag and Drop
{
  "slug": "westafricapower",
  "title": "West Africa Power",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match each empire to what gave them power.",
      "options": [
        { "id": "ghana", "text": "Ghana", "image": "", "targetText": "Trade", "targetImage": "" },
        { "id": "mali", "text": "Mali", "image": "", "targetText": "Trade", "targetImage": "" },
        { "id": "songhai", "text": "Songhai", "image": "", "targetText": "Trade", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match the Portuguese trade items.",
      "options": [
        { "id": "metals", "text": "Metals", "image": "", "targetText": "Trade item", "targetImage": "" },
        { "id": "clothes", "text": "Clothes", "image": "", "targetText": "Trade item", "targetImage": "" },
        { "id": "gold", "text": "Gold", "image": "", "targetText": "For trade", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match empires to their river location.",
      "options": [
        { "id": "ghana2", "text": "Ghana", "image": "", "targetText": "Niger River", "targetImage": "" },
        { "id": "mali2", "text": "Mali", "image": "", "targetText": "Niger River", "targetImage": "" },
        { "id": "songhai2", "text": "Songhai", "image": "", "targetText": "Niger River", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match the time period to the empires.",
      "options": [
        { "id": "ghana3", "text": "Ghana", "image": "", "targetText": "300–1600 AD", "targetImage": "" },
        { "id": "mali3", "text": "Mali", "image": "", "targetText": "300–1600 AD", "targetImage": "" },
        { "id": "songhai3", "text": "Songhai", "image": "", "targetText": "300–1600 AD", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match each group with its trade role.",
      "options": [
        { "id": "portuguese", "text": "Portuguese", "image": "", "targetText": "Traded goods", "targetImage": "" },
        { "id": "ghana4", "text": "Ghana", "image": "", "targetText": "Controlled trade", "targetImage": "" },
        { "id": "mali4", "text": "Mali", "image": "", "targetText": "Controlled trade", "targetImage": "" }
      ]
    }
  ]
},

// Looking For - Multiple Choice
{
  "slug": "lookingfor",
  "title": "Looking For",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Why were colonies started in North America?",
      "questionImage": "",
      "answers": [
        { "text": "Religious reasons", "correct": true, "image": "" },
        { "text": "Space travel", "correct": false, "image": "" },
        { "text": "Sports", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why else were colonies started?",
      "questionImage": "",
      "answers": [
        { "text": "Economic reasons", "correct": true, "image": "" },
        { "text": "Magic", "correct": false, "image": "" },
        { "text": "Vacation", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why was Plymouth Colony settled?",
      "questionImage": "",
      "answers": [
        { "text": "Religious freedom", "correct": true, "image": "" },
        { "text": "Gold", "correct": false, "image": "" },
        { "text": "Horses", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why was Jamestown settled?",
      "questionImage": "",
      "answers": [
        { "text": "Economic ventures", "correct": true, "image": "" },
        { "text": "Music", "correct": false, "image": "" },
        { "text": "Religion", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why was Pennsylvania settled?",
      "questionImage": "",
      "answers": [
        { "text": "Religious freedom", "correct": true, "image": "" },
        { "text": "Tobacco", "correct": false, "image": "" },
        { "text": "Horses", "correct": false, "image": "" }
      ]
    }
  ]
},

// Depended On - Drag and Drop
{
  "slug": "dependedon",
  "title": "Depended On",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match New England specialties.",
      "options": [
        { "id": "fishing", "text": "Fishing", "image": "", "targetText": "New England", "targetImage": "" },
        { "id": "shipbuilding", "text": "Shipbuilding", "image": "", "targetText": "New England", "targetImage": "" },
        { "id": "naval", "text": "Naval supplies", "image": "", "targetText": "New England", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match Mid-Atlantic specialties.",
      "options": [
        { "id": "livestock", "text": "Livestock", "image": "", "targetText": "Mid-Atlantic", "targetImage": "" },
        { "id": "fish", "text": "Fish", "image": "", "targetText": "Mid-Atlantic", "targetImage": "" },
        { "id": "grains", "text": "Grains", "image": "", "targetText": "Mid-Atlantic", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match Southern specialties.",
      "options": [
        { "id": "rice", "text": "Rice", "image": "", "targetText": "Southern", "targetImage": "" },
        { "id": "tobacco", "text": "Tobacco", "image": "", "targetText": "Southern", "targetImage": "" },
        { "id": "cotton", "text": "Cotton", "image": "", "targetText": "Southern", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match each colony with what it depended on.",
      "options": [
        { "id": "newenglandtools", "text": "New England", "image": "", "targetText": "Metal tools", "targetImage": "" },
        { "id": "midatlanticgrains", "text": "Mid-Atlantic", "image": "", "targetText": "Grains", "targetImage": "" },
        { "id": "southerntobacco", "text": "Southern", "image": "", "targetText": "Tobacco", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match Southern trade needs.",
      "options": [
        { "id": "southtools", "text": "Southern", "image": "", "targetText": "Equipment", "targetImage": "" },
        { "id": "southgrains", "text": "Southern", "image": "", "targetText": "Grains", "targetImage": "" },
        { "id": "southlivestock", "text": "Southern", "image": "", "targetText": "Livestock", "targetImage": "" }
      ]
    }
  ]
},

// Colonial Times - Multiple Choice
{
  "slug": "colonialtimes",
  "title": "Colonial Times",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Who did large landowners rely on for labor?",
      "questionImage": "",
      "answers": [
        { "text": "Slaves/servants", "correct": true, "image": "" },
        { "text": "Robots", "correct": false, "image": "" },
        { "text": "Kings", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who did farmers depend on for labor?",
      "questionImage": "",
      "answers": [
        { "text": "Family", "correct": true, "image": "" },
        { "text": "Soldiers", "correct": false, "image": "" },
        { "text": "Teachers", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What was a woman's main role?",
      "questionImage": "",
      "answers": [
        { "text": "Homemaker", "correct": true, "image": "" },
        { "text": "Governor", "correct": false, "image": "" },
        { "text": "Warrior", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Could women vote in colonial times?",
      "questionImage": "",
      "answers": [
        { "text": "No", "correct": true, "image": "" },
        { "text": "Yes", "correct": false, "image": "" },
        { "text": "Sometimes", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Could free African Americans own land?",
      "questionImage": "",
      "answers": [
        { "text": "Yes", "correct": true, "image": "" },
        { "text": "No", "correct": false, "image": "" },
        { "text": "Only slaves", "correct": false, "image": "" }
      ]
    }
  ]
},

// GB and The Colonies - Multiple Choice
{
  "slug": "gbandthecolonies",
  "title": "Great Britain and The Colonies",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Who controlled trade in the colonies?",
      "questionImage": "",
      "answers": [
        { "text": "Great Britain", "correct": true, "image": "" },
        { "text": "France", "correct": false, "image": "" },
        { "text": "Spain", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did Great Britain trade for raw materials?",
      "questionImage": "",
      "answers": [
        { "text": "Goods", "correct": true, "image": "" },
        { "text": "Sand", "correct": false, "image": "" },
        { "text": "Ice", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did Great Britain add to the colonies?",
      "questionImage": "",
      "answers": [
        { "text": "Taxes", "correct": true, "image": "" },
        { "text": "Freedom", "correct": false, "image": "" },
        { "text": "Gold", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who enforced the laws?",
      "questionImage": "",
      "answers": [
        { "text": "Governors", "correct": true, "image": "" },
        { "text": "Farmers", "correct": false, "image": "" },
        { "text": "Teachers", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who appointed the governors?",
      "questionImage": "",
      "answers": [
        { "text": "The King", "correct": true, "image": "" },
        { "text": "Colonists", "correct": false, "image": "" },
        { "text": "Merchants", "correct": false, "image": "" }
      ]
    }
  ]
},

// The Dec - Multiple Choice
{
  "slug": "thedeclaration",
  "title": "The Declaration of Independence",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What document listed reasons for independence?",
      "questionImage": "",
      "answers": [
        { "text": "Declaration", "correct": true, "image": "" },
        { "text": "Bill", "correct": false, "image": "" },
        { "text": "Treaty", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who was an author of the Declaration?",
      "questionImage": "",
      "answers": [
        { "text": "Jefferson", "correct": true, "image": "" },
        { "text": "Hamilton", "correct": false, "image": "" },
        { "text": "Madison", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. All people are created what?",
      "questionImage": "",
      "answers": [
        { "text": "Equal", "correct": true, "image": "" },
        { "text": "Royal", "correct": false, "image": "" },
        { "text": "Poor", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which right is named in the lyrics?",
      "questionImage": "",
      "answers": [
        { "text": "Life", "correct": true, "image": "" },
        { "text": "Silence", "correct": false, "image": "" },
        { "text": "Titles", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which goal is in the Declaration?",
      "questionImage": "",
      "answers": [
        { "text": "Happiness", "correct": true, "image": "" },
        { "text": "Conquest", "correct": false, "image": "" },
        { "text": "Empire", "correct": false, "image": "" }
      ]
    }
  ]
},

// Articles - Multiple Choice
{
  "slug": "articles",
  "title": "Articles",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What were the Articles of Confederation?",
      "questionImage": "",
      "answers": [
        { "text": "Constitution", "correct": true, "image": "" },
        { "text": "Treaty", "correct": false, "image": "" },
        { "text": "Speech", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How strong was the national government?",
      "questionImage": "",
      "answers": [
        { "text": "Weak", "correct": true, "image": "" },
        { "text": "Strong", "correct": false, "image": "" },
        { "text": "Absolute", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How many votes did each state have?",
      "questionImage": "",
      "answers": [
        { "text": "One", "correct": true, "image": "" },
        { "text": "Two", "correct": false, "image": "" },
        { "text": "Ten", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which branches were missing?",
      "questionImage": "",
      "answers": [
        { "text": "Exec/Judicial", "correct": true, "image": "" },
        { "text": "Legislative", "correct": false, "image": "" },
        { "text": "Military", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What powers did Congress lack?",
      "questionImage": "",
      "answers": [
        { "text": "Tax/Trade", "correct": true, "image": "" },
        { "text": "War/Peace", "correct": false, "image": "" },
        { "text": "Coins", "correct": false, "image": "" }
      ]
    }
  ]
},

// The Constitution - Multiple Choice
{
  "slug": "theconstitution",
  "title": "The Constitution",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What is the Constitution?",
      "questionImage": "",
      "answers": [
        { "text": "Highest law", "correct": true, "image": "" },
        { "text": "Newspaper", "correct": false, "image": "" },
        { "text": "Map", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which three branches does it set up?",
      "questionImage": "",
      "answers": [
        { "text": "Pres/Cong/Courts", "correct": true, "image": "" },
        { "text": "King/Army/Church", "correct": false, "image": "" },
        { "text": "Mayor/Council/Jury", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. In what year was the plan made?",
      "questionImage": "",
      "answers": [
        { "text": "1787", "correct": true, "image": "" },
        { "text": "1776", "correct": false, "image": "" },
        { "text": "1791", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What are the first ten amendments called?",
      "questionImage": "",
      "answers": [
        { "text": "Bill of Rights", "correct": true, "image": "" },
        { "text": "Code of Laws", "correct": false, "image": "" },
        { "text": "Federal Rules", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How many amendments passed in total?",
      "questionImage": "",
      "answers": [
        { "text": "27", "correct": true, "image": "" },
        { "text": "10", "correct": false, "image": "" },
        { "text": "50", "correct": false, "image": "" }
      ]
    }
  ]
},

// First Five - Drag and Drop
{
  "slug": "firstfive",
  "title": "First Five",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from Row A and drop it on the item in Row B that matches. Match president to order.",
      "options": [
        { "id": "washington_ord", "text": "Washington", "image": "", "targetText": "1st", "targetImage": "" },
        { "id": "adams_ord", "text": "Adams", "image": "", "targetText": "2nd", "targetImage": "" },
        { "id": "jefferson_ord", "text": "Jefferson", "image": "", "targetText": "3rd", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from Row A and drop it on the item in Row B that matches. Match event to president.",
      "options": [
        { "id": "washington_bor", "text": "Washington", "image": "", "targetText": "Bill of Rights", "targetImage": "" },
        { "id": "adams_parties", "text": "Adams", "image": "", "targetText": "Two parties", "targetImage": "" },
        { "id": "jefferson_lp", "text": "Jefferson", "image": "", "targetText": "Louisiana Purchase", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from Row A and drop it on the item in Row B that matches. Match exploration or policy.",
      "options": [
        { "id": "jefferson_lc", "text": "Jefferson", "image": "", "targetText": "Lewis & Clark", "targetImage": "" },
        { "id": "madison_war", "text": "Madison", "image": "", "targetText": "War of 1812", "targetImage": "" },
        { "id": "monroe_doc", "text": "Monroe", "image": "", "targetText": "Monroe Doctrine", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from Row A and drop it on the item in Row B that matches. Match president to order (later).",
      "options": [
        { "id": "madison_ord", "text": "Madison", "image": "", "targetText": "4th", "targetImage": "" },
        { "id": "monroe_ord", "text": "Monroe", "image": "", "targetText": "5th", "targetImage": "" },
        { "id": "adams_ord2", "text": "Adams", "image": "", "targetText": "2nd", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from Row A and drop it on the item in Row B that matches. Match summary fact.",
      "options": [
        { "id": "farm_lc", "text": "Jefferson", "image": "", "targetText": "New lands", "targetImage": "" },
        { "id": "lead_bor", "text": "Washington", "image": "", "targetText": "Bill added", "targetImage": "" },
        { "id": "policy_md", "text": "Monroe", "image": "", "targetText": "Doctrine", "targetImage": "" }
      ]
    }
  ]
},

// America Grew - Multiple Choice
{
  "slug": "americagrew",
  "title": "America Grew",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What did the Louisiana Purchase do?",
      "questionImage": "",
      "answers": [
        { "text": "Doubled size", "correct": true, "image": "" },
        { "text": "Halved size", "correct": false, "image": "" },
        { "text": "No change", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which land came by treaty from Spain?",
      "questionImage": "",
      "answers": [
        { "text": "Florida", "correct": true, "image": "" },
        { "text": "Oregon", "correct": false, "image": "" },
        { "text": "Alaska", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which became independent before joining?",
      "questionImage": "",
      "answers": [
        { "text": "Texas", "correct": true, "image": "" },
        { "text": "Utah", "correct": false, "image": "" },
        { "text": "Maine", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which territory was split with Britain?",
      "questionImage": "",
      "answers": [
        { "text": "Oregon", "correct": true, "image": "" },
        { "text": "Louisiana", "correct": false, "image": "" },
        { "text": "Hawaii", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which area joined after the war with Mexico?",
      "questionImage": "",
      "answers": [
        { "text": "California", "correct": true, "image": "" },
        { "text": "Vermont", "correct": false, "image": "" },
        { "text": "Georgia", "correct": false, "image": "" }
      ]
    }
  ]
},

// Settlers Moving - Multiple Choice
{
  "slug": "settlersmoving",
  "title": "Settlers Moving",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. When did many settlers move west?",
      "questionImage": "",
      "answers": [
        { "text": "1801–1861", "correct": true, "image": "" },
        { "text": "1700–1750", "correct": false, "image": "" },
        { "text": "1900–1920", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What land did settlers seek?",
      "questionImage": "",
      "answers": [
        { "text": "Cheap/fertile", "correct": true, "image": "" },
        { "text": "Rocky", "correct": false, "image": "" },
        { "text": "Frozen", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What helped people move faster?",
      "questionImage": "",
      "answers": [
        { "text": "Rivers/canals", "correct": true, "image": "" },
        { "text": "Footpaths", "correct": false, "image": "" },
        { "text": "Sand dunes", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which was an economic reason?",
      "questionImage": "",
      "answers": [
        { "text": "Gold Rush", "correct": true, "image": "" },
        { "text": "Snowballing", "correct": false, "image": "" },
        { "text": "Kite flying", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What belief supported expansion?",
      "questionImage": "",
      "answers": [
        { "text": "Good for country", "correct": true, "image": "" },
        { "text": "Bad idea", "correct": false, "image": "" },
        { "text": "Stay put", "correct": false, "image": "" }
      ]
    }
  ]
},

 ]
  
export default va5thSocialStudiesQuizContent;
